import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function Login({ admin = false }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome to LEE BAG");
      if (admin || u.role !== "customer") nav("/admin/dashboard");
      else nav("/account");
    } catch (er) {
      toast.error(er.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className={`min-h-[80vh] flex items-center justify-center px-6 py-12 ${admin ? "bg-[#0F0F10] text-[#FBF9F5]" : ""}`}>
      <form onSubmit={submit} className={`w-full max-w-md ${admin ? "bg-[#18181B] border border-[#27272A] p-10" : "border border-[#E2DDD5] bg-white p-10"}`}>
        <div className="text-center mb-8">
          <div className="font-serif text-2xl tracking-[0.3em]">LEE BAG</div>
          <p className="eyebrow mt-4">{admin ? "Admin Portal" : "Sign In"}</p>
        </div>
        <label className="block text-xs uppercase tracking-widest mb-1">Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className={`w-full px-3 py-2 mb-4 text-sm ${admin ? "admin-input" : "border border-[#E2DDD5] bg-transparent"}`} />
        <label className="block text-xs uppercase tracking-widest mb-1">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className={`w-full px-3 py-2 mb-6 text-sm ${admin ? "admin-input" : "border border-[#E2DDD5] bg-transparent"}`} />
        <button disabled={busy} type="submit" className={`w-full ${admin ? "bg-[#C5A059] text-[#121212] py-3 uppercase tracking-widest text-xs font-semibold" : "btn-lux"}`} data-testid="login-submit">{busy ? "…" : "Sign In"}</button>
        {!admin && <p className="text-center text-xs mt-6">New here? <Link to="/register" className="underline">Create account</Link></p>}
      </form>
    </div>
  );
}

export function Register() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Account created");
      nav("/account");
    } catch (er) {
      toast.error(er.response?.data?.detail || "Registration failed");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12">
      <form onSubmit={submit} className="w-full max-w-md border border-[#E2DDD5] bg-white p-10">
        <div className="text-center mb-8">
          <div className="font-serif text-2xl tracking-[0.3em]">LEE BAG</div>
          <p className="eyebrow mt-4">Create Account</p>
        </div>
        {["name", "email", "phone", "password"].map((k) => (
          <div key={k} className="mb-4">
            <label className="block text-xs uppercase tracking-widest mb-1">{k}</label>
            <input type={k === "password" ? "password" : k === "email" ? "email" : "text"} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} required={k !== "phone"} data-testid={`register-${k}`} className="w-full px-3 py-2 text-sm border border-[#E2DDD5]" />
          </div>
        ))}
        <button disabled={busy} className="btn-lux w-full mt-4" data-testid="register-submit">{busy ? "…" : "Create Account"}</button>
        <p className="text-center text-xs mt-6">Already have an account? <Link to="/login" className="underline">Sign in</Link></p>
      </form>
    </div>
  );
}
